import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import CustomButton from '@/components/CustomButton'
import { linkGenerator } from '@/libs/utils/language'

const PasswordBlock = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  return (
    <>
      <div className="profile__main-block">
        <div className="profile__main-block__label">
          {t('myProfile.password')}
        </div>
        <div className="profile__main-block__description">
          {t('myProfile.passwordDesc')}
        </div>
      </div>
      <CustomButton
        className="btn btn--submit mt-4"
        type="primary"
        onClick={() => {
          navigate(linkGenerator('/profile/change-password'))
        }}
      >
        {t('setPassword.title')}
      </CustomButton>
    </>
  )
}
export default PasswordBlock
